// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
import { getActiveOverlay } from './overlays';

export const isAnyPopoverCurrentlyOpen = (state: State): boolean =>
  state.ui.popovers.length !== 0;

export const isPopoverShown = (state: State, name: symbol | string): boolean =>
  state.ui.popovers.includes(name);

export const areAnyPopoversOrOverlaysCurrentlyOpen = (
  state: State,
): boolean => {
  return isAnyPopoverCurrentlyOpen(state) || !!getActiveOverlay(state);
};



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/popovers.ts